/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
} from './AdmissionStatus';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
} from './AdmissionStatusCode';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
} from './LeadAdmissionStatusInfo';

/**
 * 
 * @export
 * @interface UpdateAdmissionStatusRequest
 */
export interface UpdateAdmissionStatusRequest {
    /**
     * Legacy display name. Use `admission_status_code`.
     * @type {AdmissionStatus}
     * @memberof UpdateAdmissionStatusRequest
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * Preferred on writes; validated by per-care-setting state machine.
     * @type {AdmissionStatusCode}
     * @memberof UpdateAdmissionStatusRequest
     */
    admission_status_code?: AdmissionStatusCode;
    /**
     * 
     * @type {LeadAdmissionStatusInfo}
     * @memberof UpdateAdmissionStatusRequest
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAdmissionStatusRequest
     */
    create_esign_request?: boolean;
}

/**
 * Check if a given object implements the UpdateAdmissionStatusRequest interface.
 */
export function instanceOfUpdateAdmissionStatusRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateAdmissionStatusRequestFromJSON(json: any): UpdateAdmissionStatusRequest {
    return UpdateAdmissionStatusRequestFromJSONTyped(json, false);
}

export function UpdateAdmissionStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAdmissionStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'admission_status': !exists(json, 'admission_status') ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_code': !exists(json, 'admission_status_code') ? undefined : AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'admission_status_info': !exists(json, 'admission_status_info') ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'create_esign_request': !exists(json, 'create_esign_request') ? undefined : json['create_esign_request'],
    };
}

export function UpdateAdmissionStatusRequestToJSON(value?: UpdateAdmissionStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'admission_status': AdmissionStatusToJSON(value.admission_status),
        'admission_status_code': AdmissionStatusCodeToJSON(value.admission_status_code),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value.admission_status_info),
        'create_esign_request': value.create_esign_request,
    };
}

